//定制请求的实例

//导入axios  npm install axios
import axios from 'axios';

import { ElMessage, ElLoading } from 'element-plus'
import { router } from '@/router/index';

//定义一个变量,记录公共的前缀  ,  baseURL
// const baseURL = 'http://localhost:8080';
const baseURL =process.env.VUE_APP_SERVER_HOST;
const instance = axios.create({ baseURL })

// 定义loading实例
// let loadingInstance = null;


// 添加响应拦截器
instance.interceptors.response.use(
    result => {
        // 关闭loading
        // if (loadingInstance) {
        //     loadingInstance.close();
        // }
        
        // 如果是blob类型的响应（文件下载），直接返回data
        if (result.config.responseType === 'blob') {
            return result.data;
        }
        
        //判断业务状态码
        if (result.data.code == 200) {
            return result.data;
        }

        if (result.data.code == 401) {
            // 登录过期
            ElMessage.error(result.data.message ? result.data.message : "登录过期");
            localStorage.removeItem("token");
            // 确保DOM更新完成后再跳转
            setTimeout(() => {
                router.push("/login");
            }, 100);
            return Promise.reject(result.data);
        }

        if (result.data.code == 2) {
            // 登录过期
            ElMessage.error(result.data.message ? result.data.message : "sentry角色不匹配,无法进入");
            localStorage.removeItem("token");
            // 确保DOM更新完成后再跳转
            setTimeout(() => {
                router.push("/login");
            }, 100);
            return Promise.reject(result.data);
        }

        if (result.data.code == 403) {
            // 权限不足
            ElMessage.error(result.data.message ? result.data.message : "权限不足");
            return Promise.reject(result.data);
        }

        //操作失败
        ElMessage.error(result.data.message ? result.data.message : "服务异常")
        return Promise.reject(result.data);
    },
    err => {
        // 关闭loading
        // if (loadingInstance) {
        //     loadingInstance.close();
        // }
        //判断响应状态码，如果为401则未登录，提示请登录并跳转登录页面
        if (err.response && err.response.status) {
            if (err.response.status == 401) {
                ElMessage.error("请先登录");
                // 清除本地存储的token
                localStorage.removeItem("token");
                // 使用延迟确保DOM更新完成后再跳转
                setTimeout(() => {
                    router.push("/login");
                }, 100);
            } else if (err.response.status == 403) {
                ElMessage.error("权限不足");
            } else if (err.response.status == 500) {
                // 处理500服务器内部错误
                const errorMsg = err.response.data?.message || err.response.data?.message || "服务器内部错误";
                ElMessage.error(errorMsg);
            } else {
                ElMessage.error("服务异常");
            }
        } else {
            // 处理没有response的情况（如网络错误、服务器未响应等）
            ElMessage.error("网络错误或服务器未响应");
        }
        
        // 返回一个包含错误信息的对象，而不是直接返回err对象
        const errorInfo = {
            status: err.response?.status || 0,
            message: err.response?.data?.message || err.response?.data?.message || err.message || "请求失败",
            data: err.response?.data || null
        };
        return Promise.reject(errorInfo);
    }
)

// 请求拦截器（token）
instance.interceptors.request.use(
    (config) => {
        //请求前回调
        // 显示loading
        // loadingInstance = ElLoading.service({
        //     lock: true,
        //     text: '加载中...',
        //     background: 'rgba(0, 0, 0, 0.7)'
        // });
        //添加token
        if (localStorage.getItem("token")) {
            config.headers.Authorization = localStorage.getItem("token");
        }
        return config
    },
    (err) => {
        // 关闭loading
        // if (loadingInstance) {
        //     loadingInstance.close();
        // }
        //请求错误的回调
        return Promise.reject(err)
    }
)



export default instance;